"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitle = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTitle = styled_components_1.default.div `
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0em;
  margin: 16px 32px;
`;
const SectionTitle = ({ title }) => {
    return (react_1.default.createElement(exports.StyledTitle, null,
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: title })));
};
exports.default = SectionTitle;
//# sourceMappingURL=SectionTitle.js.map